export default "__VITE_ASSET__c439ab5a__"